import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
// import { FiFileText } from "react-icons/fi";
// import { FiRefreshCw } from "react-icons/fi";
// import { FiLoader } from "react-icons/fi";
import { FiShoppingBag } from "react-icons/fi";
import { FiClock } from "react-icons/fi";
import { FiPackage } from "react-icons/fi";
import { FiMapPin } from "react-icons/fi";
import { FiPhone } from "react-icons/fi";
import { FiXCircle } from "react-icons/fi";



function MyOrders() {

  const [orders, setOrders] = useState([]);
  const [phone, setPhone] = useState("");
  const [expandedOrders, setExpandedOrders] = useState({});

  const navigate = useNavigate();

  const toggleExpand = (orderId) => {
    setExpandedOrders(prev => ({
      ...prev,
      [orderId]: !prev[orderId]
    }));
  };

  useEffect(() => {

    const savedCustomer = localStorage.getItem("customer");

    if (savedCustomer) {
      const customer = JSON.parse(savedCustomer);
      setPhone(customer.phone);
    }

  }, []);

  useEffect(() => {

    if (!phone) return;

    fetchOrders(phone);

    const interval = setInterval(() => {
      fetchOrders(phone);
    }, 5000);

    return () => clearInterval(interval);

  }, [phone]);

  const fetchOrders = async (phoneNumber) => {

    if (!phoneNumber) return;

    const res = await API.get(`/orders/customer/${phoneNumber}`);

    setOrders(res.data);

  };

  const getStatusStyle = (status, orderType) => {

    switch (status) {

      case "pending":
        return { background: "#fff3cd", color: "#856404" };

      case "accepted":
        return { background: "#cce5ff", color: "#004085" };

      case "out_for_delivery":
        return orderType === "delivery"
          ? { background: "#ffe5b4", color: "#8a4b00" } // 🚚 delivery
          : { background: "#dcfce7", color: "#166534" }; // 🛍 pickup ready

      case "delivered":
        return { background: "#d4edda", color: "#155724" };

      case "cancelled":
        return { background: "#fee2e2", color: "#991b1b" };

      default:
        return { background: "#eee" };
    }
  };

  const getProgressStep = (status) => {

    switch (status) {
      case "pending":
        return 1;

      case "accepted":
        return 2;

      case "out_for_delivery":
        return 3;

      case "delivered":
        return 4;

      case "cancelled":
        return 0;

      default:
        return 1;
    }

  };

  const getTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);

    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(seconds / 3600);

    if (seconds < 60) return "just now";
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

    return new Date(date).toLocaleDateString();
  };

  const getStatusLabel = (status, orderType) => {

    if (orderType === "delivery") {
      return status.replaceAll("_", " ");
    }

    // Pickup mode labels
    switch (status) {
      case "pending":
        return "Order Placed";
      case "accepted":
        return "Preparing";
      case "out_for_delivery":
        return "Ready for Pickup";
      case "delivered":
        return "Picked Up";
      case "cancelled":
        return "Cancelled by Store";
      default:
        return status;
    }

  };

  const getSteps = (orderType) =>
    orderType === "delivery"
      ? ["Order Received", "Accepted", "Out for Delivery", "Delivered"]
      : ["Order Placed", "Preparing", "Ready", "Picked Up"];

  const readyOrders = orders.filter(
    order =>
      order.orderType === "pickup" &&
      order.status === "out_for_delivery"
  );

  const scrollToReady = () => {
    const el = document.getElementById("ready-order");
    el?.scrollIntoView({ behavior: "smooth" });
  };

  const SHOP = {
    name: "Manasa Stores",
    address: "Ansar complex, Mittalbail, B.C. Road",
    phone: "9972852893",
    mapsLink: "https://www.google.com/maps/dir/?api=1&destination=12.881111,75.024194"
  };


  return (

    <div
      style={{
        padding: "20px",
        maxWidth: "600px",
        margin: "auto",
        background: "#f6f8fa",
        minHeight: "100vh"
      }}
    >

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px"
        }}
      >
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "8px 14px",
            borderRadius: "8px",
            border: "1px solid #e5e7eb",
            background: "white",
            cursor: "pointer"
          }}
        >
          ← Back
        </button>

        <div style={{ textAlign: "right" }}>
          <h2 style={{
            marginBottom: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "8px",
            fontWeight: "700"
          }}>
            <FiShoppingBag />
            My Orders
          </h2>

          <div style={{
            fontSize: "13px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "6px"
          }}>
            <FiPhone size={14} style={{ color: "#6b7280" }} />

            <span style={{ color: "#6b7280" }}>
              Need help?
            </span>

            <a
              href={`tel:${SHOP.phone}`}
              style={{
                color: "#2563eb",
                fontWeight: "500",
                textDecoration: "underline",
                cursor: "pointer",
                textDecorationLine: "none"
              }}
            >
              Call now
            </a>
          </div>

          <p style={{
            fontSize: "12px",
            color: "#666",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "6px"
          }}>
            <FiClock size={14} />
            Updating every 5 seconds
          </p>
        </div>
      </div>


      <hr
        style={{
          border: "none",
          borderTop: "1px solid #e5e7eb",
          marginBottom: "20px"
        }}
      />

      {readyOrders.length > 0 && (
        <div
          onClick={scrollToReady}
          style={{
            background: "#16a34a",
            color: "white",
            padding: "12px",
            borderRadius: "10px",
            marginBottom: "15px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            cursor: "pointer"
          }}
        >
          <span>
            📦 {readyOrders.length} order{readyOrders.length > 1 ? "s are" : " is"} ready for pickup
          </span>

          <span style={{ fontSize: "12px" }}>
            Please collect
          </span>
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "20px"
        }}
      >

        <input
          placeholder="Enter phone number"
          value={phone}
          onChange={(e) => {
            const value = e.target.value;
            setPhone(value);

            const savedCustomer = JSON.parse(localStorage.getItem("customer")) || {};
            savedCustomer.phone = value;

            localStorage.setItem("customer", JSON.stringify(savedCustomer));

          }}
          style={{
            flex: 1,
            padding: "12px",
            borderRadius: "8px",
            border: "1px solid #e5e7eb",
            outline: "none",
            fontSize: "14px"
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              fetchOrders(phone)
            }
          }}
          onFocus={(e) => {
            e.target.style.border = "1px solid #16a34a"
          }}
          onBlur={(e) => {
            e.target.style.border = "1px solid #e5e7eb"
          }}
        />

        <button
          onClick={() => fetchOrders(phone)}
          style={{
            padding: "14px 18px",
            borderRadius: "8px",
            border: "none",
            background: "#16a34a",
            color: "white",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          Load
        </button>

      </div>

      {orders.length === 0 && (
        <p style={{ color: "#777", marginTop: "20px" }}>
          📭 No orders found for this phone number
        </p>
      )}

      {orders.map(order => {

        const isExpanded = expandedOrders[order._id];

        const itemsToShow = isExpanded
          ? order.items
          : order.items.slice(0, 3);

        const remainingCount = order.items.length - 3;

        const step = getProgressStep(order.status);

        const progressWidth =
          step === 4
            ? "calc(100% - 70px)"
            : `${((step - 1) / 3) * 100}%`;

        return (

          <div
            key={order._id}
            id={order.status === "out_for_delivery" ? "ready-order" : ""}
            style={{
              background: "white",
              border: "1px solid #f1f1f1",
              padding: "18px",
              marginTop: "20px",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",

              ...(order.status === "out_for_delivery" &&
                order.orderType === "pickup" && {
                border: "2px solid #16a34a",
                boxShadow: "0 0 0 3px #dcfce7"
              })

            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
            }}
          >

            <p style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
              <span style={{ display: "flex", alignItems: "center", gap: "6px", fontWeight: "600", }}>
                <FiPackage size={16} />
                Status:
              </span>



              <span
                style={{
                  ...getStatusStyle(order.status, order.orderType),
                  padding: "6px 12px",
                  borderRadius: "20px",
                  fontWeight: "600",
                  fontSize: "13px",
                  textTransform: "capitalize"
                }}
              >
                {getStatusLabel(order.status, order.orderType)}
              </span>

              <span style={{
                fontSize: "11px",
                background: order.orderType === "delivery" ? "#eff6ff" : "#f0fdf4",
                color: order.orderType === "delivery" ? "#2563eb" : "#16a34a",
                padding: "4px 8px",
                borderRadius: "10px",
                fontWeight: "600",
                marginLeft: "6px"
              }}>
                {order.orderType === "delivery" ? "Delivery" : "Pickup"}
              </span>
            </p>


            {order.status === "cancelled" && (
              <div style={{
                background: "#fee2e2",
                color: "#991b1b",
                padding: "10px",
                borderRadius: "8px",
                fontSize: "13px",
                marginTop: "10px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}>
                <FiXCircle size={14} />
                This order has been cancelled by the store
              </div>
            )}

            {order.orderType === "pickup" &&
              order.status !== "delivered" &&
              order.status !== "cancelled" && (
                <p style={{
                  fontSize: "12px",
                  color: order.status === "out_for_delivery" ? "#16a34a" : "#666",
                  fontWeight: order.status === "out_for_delivery" ? "600" : "normal",
                  marginTop: "6px"
                }}>
                  <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <FiMapPin size={14} />

                    {order.status === "out_for_delivery"
                      ? "Your order is ready! Please collect it from the store"
                      : "We’ll notify you once your order is ready for pickup"}
                  </span>
                </p>


              )}

            {order.orderType === "pickup" && (
              <div style={{
                marginTop: "10px",
                padding: "10px",
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: "8px"
              }}>

                <p style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "4px"
                }}>
                  <FiMapPin size={16} />
                  {SHOP.name}
                </p>

                <p style={{
                  fontSize: "12px",
                  color: "#666",
                  marginBottom: "8px"
                }}>
                  {SHOP.address}
                </p>



                <a
                  href={SHOP.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "12px",
                    color: "#2563eb",
                    fontWeight: "600",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  Get Directions →
                </a>

              </div>
            )}


            {order.status !== "cancelled" && (
              <>

                {/* Progress Tracker */}

                <div
                  style={{
                    position: "relative",
                    marginTop: "15px",
                    marginBottom: "15px"
                  }}
                >

                  {/* Background line */}

                  <div
                    style={{
                      position: "absolute",
                      top: "9px",
                      left: "40px",
                      right: "40px",
                      height: "3px",
                      background: "#eee",
                      zIndex: 0
                    }}
                  />

                  {/* Progress line */}

                  <div
                    style={{
                      position: "absolute",
                      top: "9px",
                      left: "40px",

                      height: "3px",
                      background: "#16a34a",
                      width: progressWidth,

                      zIndex: 1,
                      transition: "width 0.4s ease"
                    }}
                  />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      position: "relative",
                      zIndex: 2
                    }}
                  >

                    {getSteps(order.orderType).map((step, index) => {

                      const active = getProgressStep(order.status) > index;



                      return (

                        <div
                          key={index}
                          style={{
                            textAlign: "center",
                            fontSize: "11px",
                            width: "80px"
                          }}
                        >

                          <div
                            style={{
                              width: "18px",
                              height: "18px",
                              margin: "auto",
                              borderRadius: "50%",
                              background: active ? "#16a34a" : "#ddd",
                              marginBottom: "4px",
                              boxShadow: active ? "0 0 0 4px #e7f7ec" : "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "white",
                              fontSize: "11px",
                              fontWeight: "bold"
                            }}
                          >
                            {active ? "✓" : ""}
                          </div>

                          <span style={{ color: active ? "#111" : "#777" }}>
                            {step}
                          </span>



                        </div>


                      );


                    })}



                  </div>

                </div>

              </>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px"
              }}
            >
              <b>Order ID: {order._id.slice(-6)}</b>

              <span style={{ color: "#666" }}>
                {getTimeAgo(order.createdAt)}
              </span>
            </div>
            <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "10px 0" }} />

            <p
              style={{
                marginTop: "25px",
                fontSize: "19px",
                fontWeight: "bold",
                color: "#16a34a"
              }}
            >
              Total: ₹{order.totalPrice}
            </p>



            <div
              style={{
                overflow: "hidden",
                transition: "max-height 0.3s ease",
                maxHeight: isExpanded ? "500px" : "200px"
              }}
            >
              <ul
                style={{
                  marginTop: "12px",
                  paddingLeft: "0",
                  listStyle: "none"
                }}
              >
                {itemsToShow.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                      borderBottom: "1px solid #f3f3f3"
                    }}
                  >
                    <span style={{
                      fontSize: "14px",
                      fontWeight: "400"
                    }}>
                      {item.name}
                      <span style={{ color: "#777", marginLeft: "4px", fontSize: "12px" }}>
                        {item.packSize && item.unit && `(${item.packSize}${item.unit})`}
                      </span>
                    </span>
                    <b>x{item.quantity}</b>
                  </li>
                ))}

                {remainingCount > 0 && (
                  <li
                    onClick={() => toggleExpand(order._id)}
                    style={{
                      fontSize: "12px",
                      color: "#2563eb",
                      marginTop: "6px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.3s ease"
                    }}
                  >
                    {isExpanded
                      ? "Show less"
                      : `View all items (${order.items.length})`}
                  </li>
                )}
              </ul>
            </div>

          </div>

        );
      })}

    </div>

  );

}

export default MyOrders;